import { LOAD_USER_SUCCESS } from '../ActionType';

export const loadUser = (user) => (dispatch) =>
  dispatch({ type: LOAD_USER_SUCCESS, payload: { user } });
